module.exports = __webpack_public_path__ + "static/tempest-2a0c0ed233394c57e518baaf61e7580a.jpg";